import styled from "styled-components";
import { device } from "../../Helper/Responsive";
export const Form = styled.form`
	flex: 0 0 40%;

	@media ${device.laptopL} {
		/* display: none; */
		flex: 0 0 55%;
	}
	@media ${device.laptop} {
		flex: 0 0 70%;
	}
	@media ${device.tablet} {
		flex: 0 0 50%;
	}
	@media ${device.mobileL} {
		flex: 0 0 90%;
	}
`;
